module.exports = __webpack_public_path__ + "img/ic-location.2e26e8f9.svg";